module.exports = __webpack_public_path__ + "img/student_5.8eb5e9aa.png";